var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58203 0 0 3.58332 0 8C0 12.4193 3.58203 16 8 16C12.418 16 16 12.4193 16 8C16 3.58332 12.418 0 8 0ZM8 3.54839C8.74826 3.54839 9.35484 4.15497 9.35484 4.90323C9.35484 5.65148 8.74826 6.25806 8 6.25806C7.25174 6.25806 6.64516 5.65148 6.64516 4.90323C6.64516 4.15497 7.25174 3.54839 8 3.54839ZM9.80645 11.7419C9.80645 11.9557 9.63313 12.129 9.41935 12.129H6.58065C6.36687 12.129 6.19355 11.9557 6.19355 11.7419V10.9677C6.19355 10.754 6.36687 10.5806 6.58065 10.5806H6.96774V8.51613H6.58065C6.36687 8.51613 6.19355 8.34281 6.19355 8.12903V7.35484C6.19355 7.14106 6.36687 6.96774 6.58065 6.96774H8.64516C8.85894 6.96774 9.03226 7.14106 9.03226 7.35484V10.5806H9.41935C9.63313 10.5806 9.80645 10.754 9.80645 10.9677V11.7419Z",
    fill: "#C4BBFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.a7b0d9a6.svg";
export { ForwardRef as ReactComponent };